/**
 * Description: A button that sets a polaris button into loading when the handler given hasn't return,
 *              mainly to prevent button being double-clicked
 */
import React from 'react';
import {
  Button
} from 'AWS-UI-Components-React';


export class AuditButton extends React.Component {
    static defaultProps = {
        handler: () => {}
    };

    _isMounted = false;

    state = {
        loading: false,
        flag: false
    };

    componentDidMount() {
        this._isMounted = true;
      }
    
    componentWillUnmount() {
        this._isMounted = false;
    }

    async handler() {
        let handler = this.props.handler();

        // If promise is returned, button go into loading state
        if (handler && Promise.resolve(handler)) {
            // set button to loading
            this.setState({loading: true});

            // Button available again after promise has resolved or rejected (if the button is still mounted)
            try {
                await handler;
                // Check if button component is still mounted, then enable button
                if (this._isMounted) {
                    return this.setState({ loading: false });
                }
            }
            catch (e) {
                if (this._isMounted) {
                    return this.setState({ loading: false });
                }
            }
        }
    }

    changeFlag(value) {
        this.setState({ flag: value });
    }

    render() {
        return <Button
        // this.props.disabled is undefined for audit page, only used in reaudit
        disabled={this.state.flag || this.props.disabled == true} 
        text={this.props.text}
        variant="primary"
        onClick={this.handler.bind(this)} 
        loading={this.state.loading} />;
    }
}


// WEBPACK FOOTER //
// ./src/components/auditButton.jsx